export default {
  init() {

  },
  finalize() {
    $('.nav-right-accessibility-toggle').on('click', function() {
      $('#__ba_panel button.gw-launchpad-icon-button').trigger('click');
    });
  },
}


// WEBPACK FOOTER //
// ./scripts/partials/other/browsealoud.js